<script setup>
import { useRoute } from "vue-router";
import SidenavItem from "./SidenavItem.vue";
import { decrypt } from '../../utils/crypto'

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};


const profile = localStorage.getItem('setProfile');
const deProfile = !profile ? 0 : JSON.parse(decrypt(profile));
</script>
<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul  class="navbar-nav">
      <li v-if="deProfile != 0 && deProfile == '1'  || deProfile == '2'" class="nav-item">
        <sidenav-item
          to="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="nav-item">
        <sidenav-item
          to="/sales-points"
          :class="getRoute() === 'sales-points' ? 'active' : ''"
          :navText="'Puntos De Venta'"
        >
          <template v-slot:icon>
            <i
              class="fa fa-shopping-cart text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="nav-item">
        <sidenav-item
          to="/statistics"
          :class="getRoute() === 'statistics' ? 'active' : ''"
          :navText="'Estadisticas'"
        >
          <template v-slot:icon>
            <i class="fa fa-chart-pie text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="nav-item">
        <sidenav-item
          to="/invoicer"
          :class="getRoute() === 'invoicer' ? 'active' : ''"
          :navText="'Facturador'"
        >
          <template v-slot:icon>
            <i class="fa fa-users text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'  || deProfile == '3'" class="nav-item">
        <sidenav-item
          to="/invoicings"
          :class="getRoute() === 'invoicings' ? 'active' : ''"
          :navText="'Facturas'">
          <template v-slot:icon>
            <i class="fa fa-file text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="nav-item">
        <sidenav-item
          to="/comprobantes-contables"
          :class="getRoute() === 'comprobantes-contables' ? 'active' : ''"
          :navText="'Comprobantes Contables'">
        >
          <template v-slot:icon>
            <i class="fa fa-file-invoice-dollar text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '4'" class="nav-item">
        <sidenav-item
          to="/cuadres"
          :class="getRoute() === 'cuadres' ? 'active' : ''"
          :navText="'Cuadres de Caja'">
          <template v-slot:icon>
            <i class="fa fa-cash-register text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '4'" class="nav-item">
        <sidenav-item
          to="/users"
          :class="getRoute() === 'users' ? 'active' : ''"
          :navText="'Usuarios'">
          <template v-slot:icon>
            <i class="fa fa-users text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="nav-item">
        <sidenav-item
          to="/error-logs"
          :class="getRoute() === 'error-logs' ? 'active' : ''"
          :navText="'Error Logs'"
        >
          <template v-slot:icon>
            <i class="fa fa-bug text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">
          ACCOUNT PAGES
        </h6>
      </li>

      <li v-show="deProfile != 0 && deProfile == '1'" class="nav-item">
        <sidenav-item
          to="/users"
          :class="getRoute() === 'User' ? 'active' : ''"
          :navText="'Usuarios'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
